export default "__VITE_ASSET__KU4dXuaD__"